import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { UserStateService } from '@bn/auth/stores';
import { ModalState } from '@bn/web-ui/dialog';

@Component({
  templateUrl: './user-disabled-modal.component.html',
  styleUrls: ['./user-disabled-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserDisabledModalComponent {
  readonly #dialog = inject(BsModalRef);

  readonly router = inject(Router);
  readonly #accountStore = inject(UserStateService).accountStore;
  readonly billingData = this.#accountStore.billingOverview;

  public data?: ModalState;
  public readonly GB = 1000000000;

  public rechargeAccount(): void {
    this.#dialog.hide();

    this.router.navigate(['/account/billing'], {
      queryParams: {
        openRechargeModal: 'true',
      },
    });
  }

  public onClose(): void {
    this.#dialog.hide();
  }

  public get averageCost(): number {
    const totalCost =
      (this.billingData()?.MonthlyChargesEUTraffic || 0) +
      (this.billingData()?.MonthlyChargesUSTraffic || 0) +
      (this.billingData()?.MonthlyChargesASIATraffic || 0) +
      (this.billingData()?.MonthlyChargesSATraffic || 0) +
      (this.billingData()?.MonthlyChargesAFTraffic || 0);

    return totalCost / ((this.billingData()?.MonthlyBandwidthUsed ?? 0) / this.GB);
  }
}
